/* tslint:disable */
import {
  Lease,
  PropertyUnits,
  CompanyAccount,
  ChartOfAccount,
  WorkOrder,
  InvoicePaymentEntry,
  IncomeInvoiceEditMemo
} from '../index';

declare var Object: any;
export interface IncomeInvoiceInterface {
  "management_company_id"?: number;
  "lease_id": number;
  "amount": number;
  "discount"?: string;
  "vat_tax_amount": number;
  "date_due"?: Date;
  "payment_status": string;
  "chart_of_account_id": number;
  "description"?: string;
  "property_id": number;
  "property_unit_id": number;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  "work_order_id"?: number;
  lease?: Lease;
  propertyUnits?: PropertyUnits;
  property?: CompanyAccount;
  chartOfAccount?: ChartOfAccount;
  workOrder?: WorkOrder;
  invoicePaymentEntry?: InvoicePaymentEntry[];
  incomeInvoiceEditMemo?: IncomeInvoiceEditMemo[];
}

export class IncomeInvoice implements IncomeInvoiceInterface {
  "management_company_id": number;
  "lease_id": number;
  "amount": number;
  "discount": string;
  "vat_tax_amount": number;
  "date_due": Date;
  "payment_status": string;
  "chart_of_account_id": number;
  "description": string;
  "property_id": number;
  "property_unit_id": number;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  "work_order_id": number;
  lease: Lease;
  propertyUnits: PropertyUnits;
  property: CompanyAccount;
  chartOfAccount: ChartOfAccount;
  workOrder: WorkOrder;
  invoicePaymentEntry: InvoicePaymentEntry[];
  incomeInvoiceEditMemo: IncomeInvoiceEditMemo[];
  constructor(data?: IncomeInvoiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `IncomeInvoice`.
   */
  public static getModelName() {
    return "IncomeInvoice";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of IncomeInvoice for dynamic purposes.
  **/
  public static factory(data: IncomeInvoiceInterface): IncomeInvoice{
    return new IncomeInvoice(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'IncomeInvoice',
      plural: 'IncomeInvoices',
      path: 'IncomeInvoices',
      idName: 'id',
      properties: {
        "management_company_id": {
          name: 'management_company_id',
          type: 'number'
        },
        "lease_id": {
          name: 'lease_id',
          type: 'number'
        },
        "amount": {
          name: 'amount',
          type: 'number'
        },
        "discount": {
          name: 'discount',
          type: 'string',
          default: '0'
        },
        "vat_tax_amount": {
          name: 'vat_tax_amount',
          type: 'number',
          default: 0
        },
        "date_due": {
          name: 'date_due',
          type: 'Date'
        },
        "payment_status": {
          name: 'payment_status',
          type: 'string'
        },
        "chart_of_account_id": {
          name: 'chart_of_account_id',
          type: 'number'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "property_id": {
          name: 'property_id',
          type: 'number'
        },
        "property_unit_id": {
          name: 'property_unit_id',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
        "work_order_id": {
          name: 'work_order_id',
          type: 'number'
        },
      },
      relations: {
        lease: {
          name: 'lease',
          type: 'Lease',
          model: 'Lease',
          relationType: 'belongsTo',
                  keyFrom: 'lease_id',
          keyTo: 'id'
        },
        propertyUnits: {
          name: 'propertyUnits',
          type: 'PropertyUnits',
          model: 'PropertyUnits',
          relationType: 'belongsTo',
                  keyFrom: 'property_unit_id',
          keyTo: 'id'
        },
        property: {
          name: 'property',
          type: 'CompanyAccount',
          model: 'CompanyAccount',
          relationType: 'belongsTo',
                  keyFrom: 'property_id',
          keyTo: 'id'
        },
        chartOfAccount: {
          name: 'chartOfAccount',
          type: 'ChartOfAccount',
          model: 'ChartOfAccount',
          relationType: 'belongsTo',
                  keyFrom: 'chart_of_account_id',
          keyTo: 'id'
        },
        workOrder: {
          name: 'workOrder',
          type: 'WorkOrder',
          model: 'WorkOrder',
          relationType: 'belongsTo',
                  keyFrom: 'work_order_id',
          keyTo: 'id'
        },
        invoicePaymentEntry: {
          name: 'invoicePaymentEntry',
          type: 'InvoicePaymentEntry[]',
          model: 'InvoicePaymentEntry',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'invoice_id'
        },
        incomeInvoiceEditMemo: {
          name: 'incomeInvoiceEditMemo',
          type: 'IncomeInvoiceEditMemo[]',
          model: 'IncomeInvoiceEditMemo',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'invoice_id'
        },
      }
    }
  }
}
